const divFormEquipServType = {
  text: 'Próximos Vencimentos (Não obrigatório):'
};

export default divFormEquipServType;
